<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Administración Información - Activar / Inactivar Cargue FIVI</h5>
    </div>
    <div class="card-body">
      <div class="row" style="margin-top: 3px;">
        <div class="col-auto" style="text-align: center;">
          <button type="button" class="btn btn-secondary" (click)="RegresarAdminFivi()">Volver</button>
        </div>
        <div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="anio" (change)="peridoPorAnioMes()" [(ngModel)]="anioConsulta">
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
          </select>
        </div>
        <div class="col-auto">
          <label for=""><b>-</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="trimestre" (change)="peridoPorAnioMes()" [(ngModel)]="consucutivoConsulta" ><!-- [(ngModel)]="PeriodoConsulta"   [disabled]="btnGuardar"-->
            <option value="" selected="selected">Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
      <div id="tabla" class="container-fluid overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
           id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">Periodo</th>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón social</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Municipio</th>
              <th scope="col" class="text-center">Estado cargue</th>
              <th scope="col" class="text-center">Estado fuente</th>
              <th scope="col" class="text-center">Novedad</th>
              <th scope="col" class="text-center">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let L of ListaEstadosFuentes">
              <td scope="col" >{{L.perido}}</td>
              <td scope="col" >{{L.nit}}</td>
              <td scope="col" >{{L.razonSocial}}</td>
              <td scope="col" class="text-center">{{L.depto}}</td>
              <td scope="col" class="text-center">{{L.muni}}</td>
              <td scope="col" class="text-center">{{L.estadocargue}}</td>
              <td scope="col" class="text-center">{{L.estadofuente}}</td>
              <td scope="col" >{{L.novedad}}</td>
              <td scope="col" class="text-center">
                <a *ngIf="L.estadocargue=='Activo'" type="button" class="fa fa-check-square" style="color: green;  margin: 3px;" data-bs-toggle="tooltip" title="Inactivar cargue" (click)="VerificarCondiciones(L.idEstInf)"></a>
                <a *ngIf="L.estadocargue=='Inactivo'" type="button" class="fa fa-check-square" style="color: red;  margin: 3px;" data-bs-toggle="tooltip" title="Activar cargue" (click)="VerificarCondiciones(L.idEstInf)"></a>
                <a type="button" class="fa fa-calendar-check" style="color: blue;  margin: 3px; margin-left: 7px;" data-bs-toggle="tooltip" title="Ver historial" (click)="VerHistorial(L.idEstInf)"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<!--Inactivar cargue-->
<button class="btn btn-primary btn-sm" #openmodalinactivarcargue data-toggle="modal"  data-target="#Inactivar" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="Inactivar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Inactivar Cargue Fuente FIVI</h4>
        <button type="button" class="close"  aria-label="Close" data-dismiss="modal" #closemodalinactivarcargue><!---->
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-6">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="Fuente.nombEntidad" disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>NIT</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit" [(ngModel)]="Fuente.nit" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Código entidad</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti" [(ngModel)]="Fuente.codEnti" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Periodo</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodo" [(ngModel)]="PeriodoModales" disabled/></div><!---->
            </div>
          </div>
          <div>
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Observación inactivación cargue: </b>
            </div>
            <div style="text-align: center;">
               <textarea class="form-control col-11" name="observacion" rows="4" style="margin: auto; margin-top: 3px;" [(ngModel)]="ObservacionInactivar" maxlength="500"></textarea><!---->
            </div>
          </div>
          <br>
          <div>
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Seleccione la variable donde la fuente está presentando error: </b>
            </div>
            <div class="row justify-content-center" style="margin-top: 10px;">
              <div class="col-3">
                <div class="row">
                  <div class="col-auto" style="margin-right: 20px;">Saldo Vencido</div>
                  <div class="col-auto"><input class="form-check-input" type="checkbox" name="SV" [(ngModel)]="CambioEstadoCargue.errorVD"></div><!---->
                </div>
              </div>
              <div class="col-3">
                <div class="row">
                  <div class="col-auto" style="margin-right: 20px;">Número de Créditos</div>
                  <div class="col-auto"><input class="form-check-input" type="checkbox" name="NC" [(ngModel)]="CambioEstadoCargue.errorNC"></div><!---->
                </div>
              </div>
            </div>
            <br>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary col-auto" [disabled]="BtnInactivar" (click)="InactivarCargue()">Inactivar Cargue</button><!---->
            </div>
          </div>
          <div *ngIf="ActivarCargueModalInactivar">
            <br>
            <div class="card" style="margin-left: 250px; margin-right: 250px;">
              <div class="card-header text-center" style="background-color: gray;">
                <b style="color: white;">Desea activar el cargue de información para la fuente?</b>
              </div>
              <div class="card-body">
                <div class="row justify-content-center" style="margin-top: 10px;">
                  <div class="col-3">
                    <button type="button" class="btn btn-success col-auto" (click)="ActivarCargueDesdeInactivar()">Si, activar Cargue</button>
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn btn-danger col-auto" data-dismiss="modal">No, activar Cargue</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!--Activar cargue-->
<button class="btn btn-primary btn-sm" #openmodalactivarcargue data-toggle="modal"  data-target="#Activar" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="Activar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Activar Cargue Fuente FIVI</h4>
        <button type="button" class="close"  aria-label="Close" data-dismiss="modal" #closemodalactivarcargue><!---->
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-6">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="Fuente.nombEntidad" disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>NIT</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit" [(ngModel)]="Fuente.nit" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Código entidad</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti" [(ngModel)]="Fuente.codEnti" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Periodo</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodo" [(ngModel)]="PeriodoModales" disabled/></div><!---->
            </div>
          </div>
          <div>
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Observación inactivación cargue: </b>
            </div>
            <div style="text-align: center;">
               <textarea class="form-control col-11" name="observacionaprobador" rows="4" style="margin: auto; margin-top: 3px;" [(ngModel)]="ObservacionActivar" maxlength="500"></textarea><!-- -->
            </div>
          </div>
          <br>
          <div>
            <br>
            <div class="row justify-content-center">
              <button type="button" class="btn btn-secondary col-auto" [disabled]="BtnActivar" (click)="ActivarCargue()">Activar Cargue</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!--historial activación/inactivavción-->
<button class="btn btn-primary btn-sm" #openmodalverhistorial data-toggle="modal"  data-target="#historial" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="historial" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Historia de Activación</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="margin: 5px;">
          <div class="col-6">
            <div class="row"><b>Razón social</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="Fuente.nombEntidad" disabled/></div>
          </div>
          <div class="col-3">
            <div class="row"><b>NIT</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit" [(ngModel)]="Fuente.nit" disabled/></div><!---->
          </div>
          <div class="col-3">
            <div class="row"><b>Código entidad</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti" [(ngModel)]="Fuente.codEnti" disabled/></div><!---->
          </div>
        </div>
        <div class="card-body container-fluid overflow-scroll">
          <table class="table table-bordered row-border hover datatable" id="tablahist">
            <thead>
              <tr>
                <th scope="col" class="text-center col-1" rowspan="2">Fecha</th>
                <th scope="col" class="text-center col-1" rowspan="2">Periodo</th>
                <th scope="col" class="text-center col-1" rowspan="2">Tipo</th>
                <th scope="col" class="text-center col-1" rowspan="2">Usuario</th>
                <th scope="col" class="text-center" rowspan="2">Observaciones</th>
                <th scope="col" class="text-center" colspan="2">Variable Error</th>
              </tr>
              <tr>
                <th scope="col" class="text-center col-1" style="font-size: small;">Valor desembolsos</th>
                <th scope="col" class="text-center col-1" style="font-size: small;">Número créditos</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of HistorialActivacionCargue | paginate:{ itemsPerPage: 5, currentPage: page }">
                <td>{{h.fecha}}</td>
                <td>{{h.periodo}}</td>
                <td>{{h.tipo}}</td>
                <td>{{h.usuario}}</td>
                <td>{{h.observacion}}</td>
                <td style="text-align: center; justify-content: center;">
                  <div *ngIf="h.errorVD"><b>X</b></div>
                </td>
                <td style="text-align: center; justify-content: center;">
                  <div *ngIf="h.errorNC"><b>X</b></div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-end">
            <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>



